import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#ffb400' cx='12' cy='12' r='12' />,
    <path
      key='1'
      fill='#ffffff'
      d='M4.5,13.7l1.6-0.2c0.2,1.3,0.8,1.9,1.8,1.9c0.5,0,0.9-0.1,1.2-0.4s0.4-0.6,0.4-1c0-0.2,0-0.4-0.2-0.6
	s-0.3-0.3-0.5-0.4s-0.7-0.3-1.5-0.5c-0.7-0.2-1.2-0.4-1.6-0.7c-0.3-0.3-0.6-0.6-0.8-1s-0.3-0.8-0.3-1.3c0-0.5,0.1-1,0.4-1.5
	c0.2-0.4,0.6-0.8,1-1s1-0.3,1.6-0.3c1,0,1.7,0.3,2.3,0.8c0.5,0.5,0.8,1.3,0.9,2.2L9.3,9.9C9.2,9.4,9.1,9,8.8,8.8s-0.6-0.3-1-0.3
	c-0.4,0-0.8,0.1-1,0.3S6.4,9.2,6.4,9.5c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.7,0.4,1.5,0.6c0.8,0.2,1.4,0.5,1.8,0.8s0.7,0.6,0.9,1
	c0.2,0.4,0.3,0.9,0.3,1.5c0,0.9-0.3,1.6-0.8,2.2c-0.5,0.6-1.4,0.9-2.5,0.9C5.9,17.2,4.8,16,4.5,13.7z'
    />,
    <path
      key='2'
      fill='#ffffff'
      d='M12.6,7h3c0.8,0,1.3,0.1,1.7,0.3c0.4,0.2,0.7,0.5,1.1,0.9C18.8,8.5,19,9,19.2,9.7s0.3,1.5,0.3,2.4
	c0,0.9-0.1,1.6-0.3,2.3c-0.2,0.6-0.4,1.1-0.7,1.5s-0.7,0.7-1.1,0.8c-0.4,0.2-1,0.3-1.6,0.3h-3.1V7z M14.2,8.7v6.6h1.2
	c0.5,0,0.9,0,1.2-0.2c0.2-0.1,0.4-0.3,0.6-0.5c0.2-0.2,0.3-0.5,0.4-1c0.1-0.4,0.2-1,0.2-1.7c0-0.7-0.1-1.3-0.2-1.8
	c-0.1-0.4-0.3-0.8-0.5-1c-0.2-0.2-0.5-0.4-0.8-0.5c-0.2-0.1-0.7-0.1-1.3-0.1H14.2z'
    />,
  ],
  'TransportConditionGeofenceCheckpoint'
);

const TransportConditionSDCardIcon = function (props) {
  return <SvgIcon xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' {...props} />;
};

export default memo(TransportConditionSDCardIcon);
